import { Button, keyframes, styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import ZizziCoin from 'assets/icons/ZizziCoin';
import ZillionnairesClubTitle from 'assets/icons/ZillionnairesClubTitle';
import Star from 'assets/icons/Star';
import TertiaryButton from 'components/TertiaryButton';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-bottom: 40px;
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.white};
  align-items: center;
  text-align: center;
  padding: 40px 20px;
  overflow: auto;

  ${theme.breakpoints.up('sm')} {
    padding-left: 20%;
    padding-right: 20%;
  }
`;

export const TitleWrapper = styled('div')`
  width: 100%;
`;

export const ZillionnairesTitle = styled(ZillionnairesClubTitle)`
  margin-bottom: 1rem;
  max-width: 450px;
`;

export const SubHeading = styled(Typography)`
  margin-bottom: 1rem;
`;

export const CoinWrapper = styled('div')`
  position: relative;
`;

export const Coin = styled(ZizziCoin)`
  width: 170px;
  padding: 20px 0px;
`;

const starKeyframes = keyframes`
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
`;

const BasicStar = styled(Star)`
  animation: ${starKeyframes} 0.8s cubic-bezier(0.77, 0, 0.18, 1) 0s infinite alternate;
  position: absolute;
`;

export const Star1 = styled(BasicStar)`
  width: 45px;
  top: 43px;
  left: 10px;
`;
export const Star2 = styled(BasicStar)`
  width: 30px;
  top: 22px;
  left: 85px;
  animation-delay: 1000ms;
`;
export const Star3 = styled(BasicStar)`
  width: 17px;
  top: 33px;
  left: 114px;
  animation-delay: 400ms;
`;
export const Star4 = styled(BasicStar)`
  width: 25px;
  top: 72px;
  left: 135px;
  animation-delay: 1400ms;
`;
export const Star5 = styled(BasicStar)`
  width: 30px;
  top: 114px;
  left: 99px;
  animation-delay: 800ms;
`;
export const Star6 = styled(BasicStar)`
  width: 23px;
  top: 143px;
  left: 111px;
  animation-delay: 200ms;
`;
export const Star7 = styled(BasicStar)`
  width: 18px;
  top: 145px;
  left: 88px;
  animation-delay: 600ms;
`;
export const Star8 = styled(BasicStar)`
  width: 23px;
  top: 88px;
  left: 26px;
  animation-delay: 600ms;
`;
export const Star9 = styled(BasicStar)`
  width: 17px;
  top: 117px;
  left: -3px;
  animation-delay: 400ms;
`;

export const Content = styled(Typography)`
  margin-bottom: 1rem;
`;

export const StyledButton = styled(Button)`
  background-color: ${theme.palette.neutral.light};
  border-radius: 0;
  padding: 1rem;
  width: 100%;
  color: ${palette.blue[500]};
  margin: 10px 0px;
  font-weight: 700;
  &:hover {
    color: ${theme.palette.white};
  }
  ${theme.breakpoints.up('sm')} {
    max-width: 350px;
  }
`;

export const StyledTertiaryButton = styled(TertiaryButton)`
  color: ${theme.palette.white};
`;
